export const formatBytes = (bytes: number, decimals?: number): string => {
  if (bytes === 0) return '0 Bytes'
  const k = 1024
  const dm = decimals !== undefined && decimals <= 0 ? 0 : decimals || 2
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
  const i = Math.floor(Math.log(bytes) / Math.log(k))
  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i]
}

export const urlJoin = (...parts:string[]) => parts
    .join('/')
    .replace(/\/+/g, '/')
    .replace(/^(.+):\//, '$1://');